var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Component } from "react";
import { Row, Col, ModalBody } from "react-bootstrap";
import { get, uniq } from "lodash";
import { FormattedMessage, injectIntl, LangLoader } from "@irati/utils/lang";
import Hr from "@irati/ui/src/Layout/Hr";
import Loading from "@irati/ui/src/Loading";
import ProfilePicture from "@irati/ui/src/ProfilePicture";
import authentication from "@irati/auth";
import { forgotPassword } from "@irati/auth/services/password";
import { ADMIN } from "@irati-web/app/src/routeConfig";
import tracking from "@irati-tracking/admin";
import { TeamState } from "@irati/types";
import userService from "@irati/identity/services/users";
import teamService from "@irati/identity/services/teams";
import Close from "@irati/ui/src/Close";
import { isGlobalAdmin } from "@irati/identity/helpers/user/role";
import { handleActivationStatusChange } from "@irati/identity/apollo/query/UsersForBusiness";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import Button from "@irati/ui/src/Button";
import EditUserForm from "./EditUserForm";
import StyledModal from "./styled/Modal";
import Ellipsed from "./styled/Ellipsed";
import ProfilePictureContainer from "./styled/ProfilePic";
import { Activate } from "./styled/ButtonHolder";
import { Padding, Paragraph, Email, UserSummary, StyledLabel, StyledH2, AlignCenter } from "./styled";
var UserProfilePopUp = /** @class */ (function (_super) {
    __extends(UserProfilePopUp, _super);
    function UserProfilePopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveButton = React.createRef();
        _this.deactivateButton = React.createRef();
        _this.resetPasswordButton = React.createRef();
        _this.loadRef = React.createRef();
        _this.activateButton = React.createRef();
        _this.state = {
            selectedUser: null,
            show: false,
            role: null,
            team: null,
            isEditing: false
        };
        _this.show = function () {
            _this.setState({
                show: true,
                load: undefined
            });
        };
        _this.hide = function () {
            _this.setState({ show: false, isEditing: false });
        };
        _this.isActive = function () {
            var _a;
            return ((_a = _this.state.selectedUser) === null || _a === void 0 ? void 0 : _a.isEnabled) || false;
        };
        _this.handleActivate = function () {
            var load = userService.activate(_this.state.selectedUser).then(_this.handleActivationChange);
            _this.setState({ load: load, loadRef: _this.activateButton });
        };
        _this.handleDeactivate = function () {
            var load = userService.deactivate(_this.state.selectedUser).then(_this.handleActivationChange);
            _this.setState({ load: load, loadRef: _this.deactivateButton });
        };
        _this.handleActivationChange = function () {
            return userService.get(_this.state.selectedUser.uuid)
                .then(function (user) { return handleActivationStatusChange(_this.props.variables, user); })
                .then(_this.hide);
        };
        _this.handleSave = function (selectedUser) {
            if (selectedUser === void 0) { selectedUser = _this.state.selectedUser; }
            var user = _this.props.user;
            if (user.externalUserId !== selectedUser.externalUserId) {
                tracking.editUserExternalID(user.uuid);
            }
            var load = teamService
                .list(authentication.userTenant().uuid, { state: TeamState.Protected })
                .then(function (protectedTeams) {
                // need to preserve protected teams but not show them
                var userProtectedTeams = protectedTeams.filter(function (t) { return user.teamIds.includes(t.uuid); }).map(function (_a) {
                    var uuid = _a.uuid;
                    return uuid;
                });
                var userTeams = get(selectedUser, "teamIds", []) || [];
                var teamIds = uniq(__spreadArrays(userTeams, userProtectedTeams));
                var data = {
                    uuid: selectedUser.uuid,
                    firstName: selectedUser.firstName,
                    lastName: selectedUser.lastName,
                    email: selectedUser.email,
                    teamIds: teamIds,
                    phoneNumber: selectedUser.phoneNumber,
                    externalUserId: selectedUser.externalUserId
                };
                return userService.update({ user: data });
            })
                .then(_this.hide)
                .then(_this.props.onUpdate);
            _this.loadRef = _this.saveButton;
            _this.setState({ load: load });
            return load;
        };
        _this.handleResetPassword = function () {
            var load = forgotPassword(_this.props.user.email, authentication.userTenant()).then(function () {
                _this.hide();
            });
            _this.loadRef = _this.resetPasswordButton;
            _this.setState({ load: load });
        };
        _this.handleEditDetails = function () {
            _this.setState({
                isEditing: true
            });
        };
        _this.getUserTeamNames = function () {
            var teams = _this.props.teams;
            var selectedUser = _this.state.selectedUser;
            return teams
                .filter(function (team) { var _a; return (((_a = selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.teamIds) === null || _a === void 0 ? void 0 : _a.includes(team.uuid)) ? team.public_name : false); })
                .map(function (team) { return team.public_name; })
                .join(", ");
        };
        _this.updateSelectedUser = function (user) {
            _this.setState({ selectedUser: user });
        };
        _this.handleCancel = function () {
            _this.setState({ isEditing: false, selectedUser: _this.props.user });
        };
        return _this;
    }
    UserProfilePopUp.getDerivedStateFromProps = function (nextProps, prevState) {
        var user = nextProps.user;
        var forceUpdate = !prevState.show;
        if (UserProfilePopUp.shouldUpdateUser(user, prevState.selectedUser) || forceUpdate) {
            return {
                selectedUser: user
            };
        }
        return null;
    };
    UserProfilePopUp.prototype.render = function () {
        var _a = this.props, teams = _a.teams, formatMessage = _a.formatMessage;
        var _b = this.state, show = _b.show, selectedUser = _b.selectedUser, load = _b.load, isEditing = _b.isEditing;
        if (!selectedUser) {
            return null;
        }
        var isAdmin = isGlobalAdmin(authentication.business(), selectedUser);
        var email = selectedUser.email;
        var details = selectedUser.dob
            ? [{ title: formatMessage({ id: "admin.components.userProfilePopUp.dateOfBirth.title" }), value: selectedUser.dob }]
            : [];
        return (React.createElement(LangLoader, { bucket: ADMIN },
            React.createElement(StyledModal, { show: show, onHide: this.hide },
                React.createElement(ModalBody, null,
                    React.createElement(Close, { top: "20px", right: "20px", onClick: this.hide }),
                    React.createElement(Row, null,
                        React.createElement(ProfilePictureContainer, null,
                            React.createElement(ProfilePicture, { border: true, user: selectedUser, large: true })),
                        React.createElement(Padding, null, isEditing ? (React.createElement(EditUserForm, { updateSelectedUser: this.updateSelectedUser, handleSave: this.handleSave, teams: teams, selectedUser: selectedUser, handleCancel: this.handleCancel, load: load, loadRef: this.loadRef, ref: this.saveButton })) : (React.createElement(React.Fragment, null,
                            React.createElement(UserSummary, null,
                                isAdmin && (React.createElement(StyledLabel, { className: "text-center", uppercase: true }, "admin")),
                                React.createElement(StyledH2, { className: "text-center" }, firstnameLastname(selectedUser)),
                                selectedUser.teams && React.createElement(StyledLabel, { className: "text-center" }, this.getUserTeamNames())),
                            React.createElement(Hr, { large: true }),
                            React.createElement(Email, null, email),
                            React.createElement(Hr, null),
                            !this.isActive() && (React.createElement(Activate, { ref: this.activateButton, full: true, large: true, load: load, onClick: this.handleActivate },
                                React.createElement(FormattedMessage, { id: "admin.components.userProfilePopUp.activate" }))),
                            details.map(function (detail, i) { return (React.createElement(Row, { key: i },
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Paragraph, { last: i === details.length - 1 }, detail.title)),
                                React.createElement(Col, { xs: 8 },
                                    React.createElement(Ellipsed, null, detail.value)))); }),
                            details.length > 0 && React.createElement(Hr, { large: true }),
                            this.isActive() && (React.createElement(AlignCenter, null,
                                React.createElement(Button, { ref: this.resetPasswordButton, full: true, onClick: this.handleResetPassword, load: load, loadRef: this.loadRef },
                                    React.createElement(FormattedMessage, { id: "platform.resetPassword.button.resetPassword" })),
                                React.createElement(Loading, { load: load, useLoader: false }),
                                React.createElement(Hr, null),
                                React.createElement(Button, { ref: this.saveButton, onClick: this.handleEditDetails, load: load, loadRef: this.loadRef, primary: true, full: true, marginBottom: 2 },
                                    React.createElement(FormattedMessage, { id: "admin.components.userProfilePopUp.button.editDetails" })),
                                this.isActive() && (React.createElement(Button, { ref: this.deactivateButton, destructive: true, onClick: this.handleDeactivate, load: load, loadRef: this.loadRef },
                                    React.createElement(FormattedMessage, { id: "admin.components.userProfilePopUp.button.deactivate" })))))))))))));
    };
    UserProfilePopUp.shouldUpdateUser = function (userA, userB) {
        var emptyUser = { Etag: "" };
        var newUser = userA || emptyUser;
        var currentUser = userB || emptyUser;
        // is new user
        if (newUser.uuid !== currentUser.uuid) {
            return true;
        }
        return false;
    };
    return UserProfilePopUp;
}(Component));
export default injectIntl(UserProfilePopUp, { withRef: true });
